import { frontendURL } from '../../../helper/URLHelper';

const SettingsWrapper = () => import('../settings/Wrapper.vue');
const PresentationCalendar = () => import('./PresentationCalendar.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/presentation-calendar'),
    name: 'presentation_calendar',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: SettingsWrapper,
    props: {
      headerTitle: 'PRESENTATION_CALENDAR.HEADER',
      icon: 'calendar',
      showNewButton: false,
      fullWidth: true,
      keepAlive: false,
    },
    children: [
      {
        path: '',
        name: 'presentation_calendar_index',
        meta: {
          permissions: ['administrator', 'agent'],
        },
        component: PresentationCalendar,
      },
    ],
  },
];
